import * as t from 'io-ts';
import * as E from 'fp-ts/Either';
import { failure } from 'io-ts/PathReporter';
import { pipe } from 'fp-ts/function';

export function decode<A, Output, Input>(
  codec: t.Type<A, Output, Input>,
  input: Input,
): A {
  return pipe(
    codec.decode(input),
    E.getOrElseW((errors) => {
      throw new Error(failure(errors).join('\n'));
    }),
  );
}

// Transform an enum into an io-ts codec
export function fromEnum<EnumType extends string>(
  enumName: string,
  theEnum: Record<string, EnumType>,
): t.Type<EnumType, EnumType, unknown> {
  const isEnumValue = (input: unknown): input is EnumType =>
    Object.values<unknown>(theEnum).includes(input);

  return new t.Type<EnumType>(
    enumName,
    isEnumValue,
    (input, context) =>
      isEnumValue(input) ? t.success(input) : t.failure(input, context),
    t.identity,
  );
}

export function optional<A, O>(
  codec: t.Type<A, O, unknown>,
): t.UnionC<[t.UndefinedC, t.Type<A, O, unknown>]> {
  return t.union([t.undefined, codec]);
}
